// extracted by mini-css-extract-plugin
module.exports = {"container":"NewOrderProceedButton_container__czvdA","proceedNote":"NewOrderProceedButton_proceedNote__I_NjF","proceedButton":"NewOrderProceedButton_proceedButton__52_uw"};